<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [backButton]="true"
    [title]="'Add Credential'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper *ngIf="loaded">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <tidy-card>
      <form [formGroup]="form">
        <ng-container *ngIf="!prefillCredentialType">
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [label]="'Category'"
              [form]="form.controls.category"
              formControlName="category"
              [items]="categories"
              [icon]="'assets/svg/list-outline.svg'"
              (optionChange)="onCategoryChange($event)">
            </tidy-select>
          </tidy-row>

          <tidy-row *ngIf="selectedCategory" class="field-bottom-padding">
            <tidy-select
              [label]="'Type'"
              [form]="form.controls.credential_type"
              formControlName="credential_type"
              [items]="types"
              [icon]="'assets/svg/pricetags-outline.svg'"
              (optionChange)="onTypeChange($event)">
            </tidy-select>
          </tidy-row>
        </ng-container>

        <ng-container *ngIf="prefillCredentialType">
          <tidy-row class="field-bottom-padding">
            <tidy-text
              [header]="prefillCredentialLabel"
              [translate]="false">
            </tidy-text>
          </tidy-row>
        </ng-container>

        <tidy-row *ngIf="showTextInput" class="field-bottom-padding">
          <tidy-input
            formControlName="text_value"
            [label]="textInputLabel"
            [form]="form.controls.text_value"
            [icon]="'assets/svg/text.svg'"
            [activeIcon]="'assets/svg/text-tidy-green.svg'"
            [errorMessage]="'Please enter a value.'"
            [submitted]="submitted"
            [placeholder]="textInputPlaceholder">
          </tidy-input>
        </tidy-row>
      </form>

      <tidy-row *ngIf="showFileUpload" class="field-bottom-padding">
        <tidy-file-upload
          [accept]="'image/*'"
          [multiple]="false"
          [label]="'Upload File'"
          [images]="uploadedImages"
          [showPreview]="true"
          [showDeleteButton]="true"
          [showDownloadButton]="false"
          (addedImagesChange)="onFilesAdded($event)"
          (removedImageChange)="onFileRemoved($event)"
          (onError)="onFileError($event)">
        </tidy-file-upload>
      </tidy-row>

      <tidy-row *ngIf="isUploading">
        <tidy-text [helper]="'Uploading file...'"></tidy-text>
      </tidy-row>
    </tidy-card>

    <tidy-error-message
      *ngIf="errorMessage"
      [text]="errorMessage">
    </tidy-error-message>

    <tidy-button
      [text]="'Submit'"
      [action]="submit.bind(this)"
      class="secondary">
    </tidy-button>
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
